import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Alert } from 'react-bootstrap'

/**
 * @param {{
 *    color: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'dark' | 'light'
 *    className?: string
 * }} props
 * @returns {React.Component}
 */
const ZariAlert = ({ color, className, ...props }) => {
  return <Alert {...props} className={clsx('zr-alert', className)} variant={color} />
}

ZariAlert.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string
}

export default ZariAlert
